module.exports = __webpack_public_path__ + "static/media/design-categoryicon.ace0c6d5.png";